const define = {
    "buttonText.discoverDefineClassic": "DEFINE® CLASSIC 經典大地色系",
    "buttonText.discoverDefineFresh": "DEFINE® FRESH 大自然色系",
    "buttonText.findStores": "搜尋ACUVUE®特約經銷商",
    "buttonText.learnMore": "了解更多",
    "buttonText.shopNow": "立即預約驗配",
    "buttonText.tryTheVirtualMirror": "虛擬試戴",
    "features.paragraph1.title": "手繪美瞳，立體細緻",
    "features.paragraph1.description": "𣎴規則花紋與虹膜自然融合，配戴效果更細緻奪目",
    "features.paragraph2.title": "以兩大舒適﹑安全技術精心打造",
    "features.paragraph2.description": "獨有 LACREON® 鎖濕科技，20 小時長效鎖濕¹，全日水潤舒適。色素夾層設計，兩塊鏡片夾住色素層，確保色素同眼球零接觸，安全不刮眼。",
    "features.paragraph3.title": "國際認可防UV<span>##</span>",
    "features.paragraph3.freshdescription": "高效的防紫外光保護 </br> 97% UVB 以及 81% UVA",
    "features.paragraph3.classicdescription": "高效的防紫外光保護 </br> 97% UVB 以及 81% UVA",
    "headline.classic.description": "一雙透亮自然的閃耀眼睛，打造懾人亮眼效果。針對亞洲女性的眼睛而設計，1-DAY ACUVUE® DEFINE® CLASSIC 即棄式美瞳鏡片能令眼睛看起來更大更透亮",
    "headline.classic.title": "DEFINE® CLASSIC 經典大地色系",
    "headline.fresh.description": "1-DAY ACUVUE® DEFINE® FRESH 色調靈感源自大自然，襯出獨有風格；手繪花紋細節與虹膜完美糅合，令你更炫目亮眼",
    "headline.fresh.title": "DEFINE® FRESH 大自然色系",
    "lensWear.howToPut": "如何配戴及除下隱形眼鏡。",
    "lensWear.insert1.description": "使用溫和的肥皂液清潔雙手並印乾手指，才接觸隱形眼鏡。",
    "lensWear.insert1.title": "徹底洗淨雙手",
    "lensWear.insert2.description": "隱形眼鏡應該像一個有直邊的碗。如果邊緣外翻，可能隱形眼鏡被反轉。",
    "lensWear.insert2.title": "檢查隱形眼鏡",
    "lensWear.insert3.description": "將隱形眼鏡置於食指尖端，用中指及另一隻手的食指拉開上下眼瞼。",
    "lensWear.insert3.title": "拉開眼皮",
    "lensWear.insert4.description": "向上看，輕輕將隱形眼鏡放在眼睛上。 放開眼瞼並閉上眼睛讓隱形眼鏡固定位置。",
    "lensWear.insert4.title": "放置隱形眼鏡",
    "lensWear.insertion": "配戴隱形眼鏡",
    "lensWear.removal": "除下隱形眼鏡",
    "lensWear.remove1.description": "確保手部清潔，然後往上看，並用中指輕輕拉下眼皮。",
    "lensWear.remove1.title": "輕輕拉下眼皮",
    "lensWear.remove2.description": "用食指輕觸隱形眼鏡的下緣，並將其推到下眼白位置。",
    "lensWear.remove2.title": "眼珠轉向上並拉下你的下眼瞼",
    "lensWear.remove3.description": "用你的拇指和食指指頭，輕輕地從眼睛夾出隱形眼鏡。",
    "lensWear.remove3.title": "輕輕地用手指頭夾出隱形眼鏡",
    "lensWear.remove4.description": "ACUVUE® DEFINE®為每日拋棄型隱形眼鏡，可在配戴一日後就直接丟棄。",
    "lensWear.remove4.title": "丟棄你的隱形眼鏡",
    "lensWear.title": "隱形眼鏡新手配戴指南",
    "references.content": "<p>1 JJV Data on File 28 March 2025: Material Properties of 1-DAY ACUVUE® DEFINE® with LACREON® Brand Contact Lenses both Original Define and Color Enrichment Pattern range lenses, including AFM and SEM testing and the Cosmetic Pattern Development</br></br><sup>##</sup>符合美國國家標準學會（ANSI）美國食物及藥物管理局（FDA）及國際標準組織（ISO）的標準</br></br>警告：有吸收紫外光能力的隱形眼鏡不能代替能阻擋紫外光的太陽眼鏡，因為有吸收紫外光能力的隱形眼鏡只覆蓋眼球的一部份。因此，隱形眼鏡配戴者必須按指示繼續配戴能阻擋紫外光的太陽眼鏡。長時間地曝露於紫外光輻射是白內障相關的危險因素之一。影響程度是基於一系列的因素，如環境因素（海拔、地理位置、雲層遮蓋）和個人因素（戶外運動的性質和程度）。防紫外光的隱形眼鏡能提供對有害紫外光輻射的防護，但並未有臨床研究證實配戴防紫外光隱形眼鏡能減少發生白內障和其他眼部疾病。請諮詢您的專業眼科視光師以獲取更多的信息。</br></br>HKM20260210_003</p>",
    "related.discover": "探索",
    "showNow.title": "立即預約驗配",
    "showNow.description": "立即驗配DEFINE®",
    "showNow.physical.details": "搜尋ACUVUE®特約經銷商",
    "specs.additionalInfo": "更多資訊",
    "specs.baseCurve": "鏡片弧度",
    "specs.baseCurve.detail": "8.5mm",
    "specs.centre": "鏡片直徑/著色直徑",
    "specs.centre.fresh.detail": "14.2 mm / 13.0 mm",
    "specs.centre.classic.detail": "14.2 mm / 13.0 mm",
    "specs.internal": "鏡片鎖濕科技",
    "specs.internal.detail": "LACREON®鎖濕科技",
    "specs.material": "鏡片材質",
    "specs.material.detail": "水凝膠",
    "specs.oxygen": "透氧率",
    "specs.oxygen.detail": " (Dk/t) (邊界和邊緣校正) 25.5 x 10-9 (-3.00D)",
    "specs.packageSize": "包裝",
    "specs.packageSize.fresh.detail": "30片/盒",
    "specs.packageSize.classic.detail": "30片/盒",
    "specs.freshpowerRange": "度數",
    "specs.classicpowerRange": "度數",
    "specs.freshpowerRange.detail": "平光 (沒有度數) <br />近視50度 – 600度 (每25度一級)<br />近視650度 – 900度 (每50度一級)",
    "specs.classicpowerRange.detail": "平光 (沒有度數) <br />近視50度 – 600度 (每25度一級)<br />近視650度 – 900度 (每50度一級)",
    "specs.specifications": "產品規格",
    "specs.water": "含水量",
    "specs.water.detail": "58%"
}

const download_now = {
  "download_now.title": "立即登記成為MyACUVUE® App會員",
  "download_now.p": "尊享獨家優惠，每次購物亦可即時獲贈積分獎賞！",
  "download_now.button": "Learn More",
}

export default {
  ...define,
  ...download_now
};
